// extracted by mini-css-extract-plugin
export var container = "Video-module--container--2UOJ2";
export var overlayContainer = "Video-module--overlayContainer--3gHXe";
export var thumbnail = "Video-module--thumbnail--1nZ4X";
export var content = "Video-module--content--Hz-2o";
export var overlayHidden = "Video-module--overlayHidden--CBf7M";
export var overlayFilter = "Video-module--overlayFilter--3zIrk";